import { Component, ViewChild, ElementRef } from '@angular/core';
import { MessageData } from './message-data';
import { MessageType } from './message-type.enum';
declare var $: any;

@Component({
    selector: 'custom-field-delete',
    templateUrl: './custom-field-delete.component.html',
    styleUrls: ['./custom-field-delete.component.css']
})

export class CustomFieldDeleteComponent {
  @ViewChild('customFieldDelete', { static: false }) customFieldDelete: ElementRef;
  private dialogEl: any;
  private message: MessageData = new MessageData(); 
    
  constructor() { }

  ngOnInit() {
    this.dialogEl = $('#customFieldDelete');
  }

  public show(text: string, type: MessageType, data?: any, caption?: string, onConfirm?: () => void, onReject?: () => void, onClose?: () => void) {
    var msg = new MessageData();
    msg.text = text;
    msg.data = data;
    msg.caption = caption;
    switch (type) {
      case 0:
        msg.type = 'ok';
        break;
      case 1:
        msg.type = 'yes/no';
        break;
      case 2:
        msg.type = 'ok/cancel';
        break;
      case 3:
        msg.type = 'yes/no/cancel';
        break;
      default: 'N/A';
    }
    msg.confirm = onConfirm;
    msg.reject = onReject;
    msg.close = onClose;

    this.message = msg;

    this.dialogEl.modal({
      show: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  private confirm() {
    if (this.message.confirm !== undefined && this.message.confirm !== null)
      this.message.confirm();
    this.close();
  }

  private reject() {
    if (this.message.reject !== undefined && this.message.reject !== null)
      this.message.reject();
    this.close();
  }

  private close() {
    var that = this;
    this.dialogEl.on("hidden.bs.modal", function () {
      if (that.message.close !== undefined && that.message.close !== null) {
        that.message.close();
        that.dialogEl.off("hidden.bs.modal");
      }
    });
    this.dialogEl.modal('hide');
  }

  private stringIsNotNullOrEmpty(text: string): boolean {
    if (text) {
      return text !== null && text.length > 0;
    } else
      return false;
  }
}
